{
  "header": "Whoops—looks like you're trying to accept an invite to Elements",
  "subHeader": "Please use your phone to accept your invitation.\n That way we can connect your account to your advisor's directly in the Elements app."
}
